import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {tap} from 'rxjs/operators';
import {MIHttpClientService} from '../../shared/mi-http-client.service';

@Injectable({
  providedIn: 'root',
})
export class LogoService {

  public loading = true;
  private cache: { [organizationId: string]: string } = {};

  constructor(
    private http: HttpClient,
    private miClient: MIHttpClientService,
  ) {
  }

  public getUrl(organizationId: string): Observable<string> {
      this.loading = false;
      if (this.cache[organizationId]) {
        return of(this.cache[organizationId]);
      } else {
        this.loading = true;
        return this.http.get(
           environment.apiUrl + 'organizations/' + encodeURIComponent(organizationId) + '/logo',
          {responseType: 'text'},
        ).pipe(
          tap(() => this.loading = false),
          tap((url: string) => this.cache[organizationId] = url),
        );
      }
  }

  /**
   * Get fresh url to logo since the existing one can not be used in export to pdf.
   */
  public getNewUrl(): Observable<string> {
    return this.miClient.getText('logo');
  }
}
